import { Common } from "apiEndPoints";
import { logger } from "utils";
import APIrequest from "../axios";

export const CommonService = {
  countryService: async (queryParams) => {
    try {
      const payload = {
        ...Common.country,
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  stateService: async (queryParams) => {
    try {
      const payload = {
        ...Common.state,
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  unreadNotificationCountService: async (queryParams) => {
    try {
      const payload = {
        ...Common.unreadNotificationCount,
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  notificationStatusService: async () => {
    try {
      const payload = {
        ...Common.notificationStatus,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  notificationService: async ({ queryParams }) => {
    try {
      const payload = {
        ...Common.notification,
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  verifyMemorialTokenService: async (bodyData) => {
    try {
      const payload = {
        ...Common.verifyMemorialToken,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
};
